module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-4a8cea9f.png";